/**
 * @generated SignedSource<<bb1896ad1bfbe11e4615018e3a58b318>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SongManageShare_user$data = {
  readonly email: string;
  readonly id: string;
  readonly " $fragmentType": "SongManageShare_user";
};
export type SongManageShare_user$key = {
  readonly " $data"?: SongManageShare_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SongManageShare_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SongManageShare_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9885aaaae41d552aae0d814d976b8288";

export default node;
